<div class="homepage">
  <app-homepage-header [logoSrc]="'logos/brand/rimini-agentic-ux-logo-and-tagline-black.svg'" [user]="user" [basePath]="basePath"
    [profiles]="profiles" (profileChange)="onProfileChange($event)"></app-homepage-header>

  <main class="homepage-main">
    <section class="hero-section">
      <h1 class="hero-title">Enjoy your coffee. We got this. <img class="smiley-icon" src="smiley.png" /></h1>

      <app-ai-search-bar [placeholder]="'Ask anything ...'" [(value)]="searchValue" [isRecording]="isRecording"
        [attachedFiles]="attachedFiles" (search)="onSearch($event)" (voiceInput)="onVoiceInput()"
        (filesChanged)="onFilesChanged($event)" (fileError)="onFileError($event)"></app-ai-search-bar>

      <div class="suggestions-container">
        <app-suggestion-badge *ngFor="let suggestion of suggestions" [text]="suggestion"
          (badgeClick)="onSuggestionClick($event)"></app-suggestion-badge>
      </div>
    </section>

    <section class="recommendations-section">
      <div class="section-header">
        <h2 class="section-title">AI Recommendations</h2>
        <div class="toggle-buttons">
          <button class="toggle-btn" [class.active]="selectedPeriod === 'daily'"
            (click)="selectPeriod('daily')">Daily</button>
          <button class="toggle-btn" [class.active]="selectedPeriod === 'weekly'"
            (click)="selectPeriod('weekly')">Weekly</button>
          <button class="toggle-btn" [class.active]="selectedPeriod === 'monthly'"
            (click)="selectPeriod('monthly')">Monthly</button>
        </div>
      </div>
      <div class="recommendations-grid">
        <app-homepage-recommendation-card *ngFor="let recommendation of recommendations"
          [recommendation]="recommendation"
          (actionClick)="onRecommendationAction($event)"></app-homepage-recommendation-card>
      </div>
    </section>

    <section class="workspaces-section">
      <h2 class="section-title">My Workspaces</h2>
      <div class="workspaces-grid">
        <app-workspace-card *ngFor="let workspace of workspaces" [workspace]="workspace"
          (workspaceClick)="onWorkspaceClick($event)"></app-workspace-card>
      </div>
    </section>
  </main>

  <app-homepage-footer [clientLogoSrc]="'logos/clients/client-logo.svg'" [clientText]="'Company, Inc. All rights reserved ©2025'"
    [riminiLogoSrc]="'logos/brand/riministreet-white.svg'"></app-homepage-footer>

  <app-chat-dialog [userAvatarSrc]="user.avatar" [userProfile]="user.name.toLowerCase()"></app-chat-dialog>
</div>
